import { render, staticRenderFns } from "./PharmaceuticalManagement.vue?vue&type=template&id=6d463ff0&scoped=true&"
import script from "./PharmaceuticalManagement.vue?vue&type=script&lang=js&"
export * from "./PharmaceuticalManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d463ff0",
  null
  
)

export default component.exports